function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Row, Col, Container } from "react-bootstrap";
import { Input, Form, Modal, Skeleton, Descriptions, Tabs, Space, Collapse, QRCode, DatePicker, Alert, Button, notification } from "antd";
import { QrReader } from "react-qr-reader";
import { Icon } from "@iconify/react";
import Common from './includes/Common';
import { TrashFill, PencilSquare } from "react-bootstrap-icons";
import AddHospitalizationItem from './forms/AddHospitalizationItem';
import AddVitalSigns from './forms/AddVitalSigns';
import moment from 'moment';
import dayjs from 'dayjs';
import Moment from "react-moment";
import { Table } from "react-bootstrap";
import EditVitalSigns from './forms/EditVitalSigns';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Care = function Care() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    scanResult = _useState2[0],
    setScanResult = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    scanError = _useState4[0],
    setScanError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    success = _useState6[0],
    setSuccess = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isPatientSearching = _useState8[0],
    setIsPatientSearching = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    patient = _useState0[0],
    setPatient = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    details = _useState10[0],
    setDetails = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    errorMessage = _useState12[0],
    setErrorMessage = _useState12[1];
  var _useState13 = useState(moment().startOf('month').format()),
    _useState14 = _slicedToArray(_useState13, 2),
    vsFrom = _useState14[0],
    setVsFrom = _useState14[1];
  var _useState15 = useState(moment().endOf('month').format()),
    _useState16 = _slicedToArray(_useState15, 2),
    vsTo = _useState16[0],
    setVsTo = _useState16[1];
  var _useState17 = useState(moment().startOf('month').format()),
    _useState18 = _slicedToArray(_useState17, 2),
    billFrom = _useState18[0],
    setBillFrom = _useState18[1];
  var _useState19 = useState(moment().endOf('month').format()),
    _useState20 = _slicedToArray(_useState19, 2),
    billTo = _useState20[0],
    setBillTo = _useState20[1];
  var _useState21 = useState([]),
    _useState22 = _slicedToArray(_useState21, 2),
    vsHistory = _useState22[0],
    setVsHistory = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    billsHistory = _useState24[0],
    setBillsHistory = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    vsErrorMessage = _useState26[0],
    setVsErrorMessage = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    billsErrorMessage = _useState28[0],
    setBillsErrorMessage = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    vsLoading = _useState30[0],
    setVsLoading = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    billsLoading = _useState32[0],
    setBillsLoading = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isDataChanged = _useState34[0],
    setIsDataChanged = _useState34[1];
  var _useState35 = useState(0),
    _useState36 = _slicedToArray(_useState35, 2),
    totalAmount = _useState36[0],
    setTotalAmount = _useState36[1];
  var _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    selectedSign = _useState38[0],
    setSelectedSign = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    showEditVs = _useState40[0],
    setShowEditVs = _useState40[1];
  useEffect(function () {
    setIsPatientSearching(true);
    axios.get(Common.baseApiUrl + "getadmissiondetails/" + scanResult + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setDetails(response.data.hospitalization);
        setPatient(response.data.hospitalization.customer);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsPatientSearching(false);
    });
  }, [scanResult]);
  useEffect(function () {
    setIsDataChanged(false);
    if (patient == null || details == null) return;
    setVsLoading(true);
    axios.get(Common.baseApiUrl + "getvitalsignshistory/" + vsFrom + "/" + vsTo + "/" + patient.id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setVsHistory(response.data.signs);
      } else {
        setVsErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setVsErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setVsLoading(false);
    });
  }, [scanResult, patient, isDataChanged, vsFrom, vsTo]);
  useEffect(function () {
    setIsDataChanged(false);
    if (patient == null || details == null) return;
    setBillsLoading(true);
    axios.get(Common.baseApiUrl + "getadmissionbillshistory/" + details.id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setBillsHistory([]);
        setTotalAmount(0);
        response.data.bills.forEach(function (b) {
          b.bill_items.forEach(function (e) {
            setBillsHistory(function (prev) {
              return [].concat(_toConsumableArray(prev), [e]);
            });
            setTotalAmount(function (prev) {
              return prev + e.business_account_medical_item.base_price;
            });
          });
        });
      } else {
        setBillsErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setBillsErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setBillsLoading(false);
    });
  }, [scanResult, patient, isDataChanged]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      minHeight: "580px"
    },
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsxs(Col, {
        lg: 5,
        md: 5,
        sm: 12,
        children: [/*#__PURE__*/_jsx(Input, {
          value: scanResult,
          prefix: /*#__PURE__*/_jsx(Icon, {
            icon: "medical-icon:medical-records"
          }),
          size: "large",
          placeholder: "ID Patient",
          onChange: function onChange(v) {
            setScanResult(v.target.value);
          }
        }), /*#__PURE__*/_jsx(QrReader, {
          constraints: {
            facingMode: "user"
          } // Use rear camera
          ,
          onResult: function onResult(result, error) {
            if (result) {
              setScanResult(result === null || result === void 0 ? void 0 : result.text);
            }
          },
          style: {
            width: "100%",
            borderRadius: "7px"
          }
        }), scanError.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: scanError,
          showIcon: true,
          closable: true
        }), scanError.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: success,
          showIcon: true,
          closable: true
        })]
      }), /*#__PURE__*/_jsxs(Col, {
        children: [details && details.customer && details.bed && details.bed.room && /*#__PURE__*/_jsx(Tabs, {
          animated: true,
          items: [{
            label: /*#__PURE__*/_jsx("b", {
              children: "Administration"
            }),
            key: 1,
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                className: "user-info",
                children: /*#__PURE__*/_jsxs("div", {
                  className: "user-personal-info cool-radius",
                  style: {
                    backgroundColor: "#DAF3ED"
                  },
                  children: [/*#__PURE__*/_jsxs(Descriptions, {
                    column: {
                      xs: 1,
                      sm: 2,
                      md: 3,
                      lg: 3,
                      xl: 3,
                      xxl: 3
                    },
                    children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Pr\xE9nom"
                      }),
                      children: details.customer.firstname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Nom"
                      }),
                      children: details.customer.lastname
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Tel."
                      }),
                      children: details.customer.mobile.toString().slice(3)
                    }), /*#__PURE__*/_jsx(Descriptions.Item, {
                      label: /*#__PURE__*/_jsx("b", {
                        children: "Montant caution"
                      }),
                      children: details.deposit.toLocaleString("Fr")
                    })]
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      sm: 6,
                      xs: 6,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Icon, {
                          icon: "la:door-open",
                          width: "38",
                          height: "38"
                        }), /*#__PURE__*/_jsx("b", {
                          children: details.bed.room.label
                        })]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      sm: 6,
                      xs: 6,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Icon, {
                          icon: "medical-icon:i-inpatient",
                          width: "38",
                          height: "38"
                        }), /*#__PURE__*/_jsx("d", {
                          children: details.bed.label
                        })]
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx(Collapse, {
                accordion: true,
                ghost: true,
                items: [{
                  key: 1,
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Prendre les param\xE8tres"
                  }),
                  children: /*#__PURE__*/_jsx(AddVitalSigns, {
                    patient: details.customer,
                    handler: function handler() {
                      setIsDataChanged(true);
                    }
                  })
                }, {
                  key: 2,
                  label: /*#__PURE__*/_jsx("b", {
                    children: "Examens complementaire"
                  }),
                  children: /*#__PURE__*/_jsx(AddHospitalizationItem, {
                    patient: details.customer,
                    hospitalization_id: details.id,
                    handleUpdate: function handleUpdate() {
                      setIsDataChanged(true);
                    }
                  })
                }]
              })]
            })
          }, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Historique"
            }),
            key: 2,
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx(RangePicker, {
                  onChange: function onChange(p) {
                    setVsFrom(dayjs(p[0].$d).format());
                    setVsTo(dayjs(p[1].$d).format());
                  }
                }), vsHistory.map(function (e) {
                  return /*#__PURE__*/_jsxs("div", {
                    style: {
                      padding: "12px",
                      borderRadius: "7px",
                      marginBottom: "11px",
                      background: "#F3F2EE"
                    },
                    children: [/*#__PURE__*/_jsxs(Descriptions, {
                      column: {
                        xs: 2,
                        sm: 2,
                        md: 2,
                        lg: 2,
                        xl: 3,
                        xxl: 4
                      },
                      title: /*#__PURE__*/_jsx(Moment, {
                        style: {
                          color: "#F37A5C",
                          fontWeight: "bold",
                          fontSize: "13px"
                        },
                        date: e.created_at,
                        format: "DD/MM/YYYY HH:mm"
                      }),
                      children: [/*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Temp\xE9rature"
                        }),
                        children: [e.temperature, " ", e.temperature && " °C"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Glyc\xE9mie"
                        }),
                        children: [e.blood_sugar, " ", e.blood_sugar && " mmol/L"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "SPO2"
                        }),
                        children: [e.saturation, " ", e.saturation && " %"]
                      }), /*#__PURE__*/_jsx(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Ta"
                        }),
                        children: e.blood_pressure_systole && e.blood_pressure_systole + "/" + e.blood_pressure_diastole + " mmHg"
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Freq. R"
                        }),
                        children: [e.breathe_rate, " ", e.breathe_rate && " RPM"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Freq. C"
                        }),
                        children: [e.heart_rate, " ", e.heart_rate && " BPM"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Taille"
                        }),
                        children: [e.height, " ", e.height && " Cm"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Poids"
                        }),
                        children: [e.weight, " ", e.weight && " Kg"]
                      }), /*#__PURE__*/_jsxs(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "IMC"
                        }),
                        children: [e.bmi, " ", e.bmi && " Kg/M²"]
                      })]
                    }), /*#__PURE__*/_jsx("div", {
                      style: {
                        background: "#E6E2D5",
                        padding: "9px 7px",
                        marginTop: "12px",
                        borderRadius: "4px"
                      },
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            setSelectedSign(e);
                            setShowEditVs(true);
                          },
                          children: /*#__PURE__*/_jsx(PencilSquare, {
                            size: 16
                          })
                        }), contextHolder, /*#__PURE__*/_jsx(Button, {
                          type: "default",
                          onClick: function onClick() {
                            confirm({
                              title: /*#__PURE__*/_jsx("b", {
                                children: "Confirmez - vous ? "
                              }),
                              content: /*#__PURE__*/_jsxs("p", {
                                children: ["La suppression des constantes pris le ", /*#__PURE__*/_jsx(Moment, {
                                  date: e.created_at,
                                  format: "DD/MM/YYYY"
                                }), " ?"]
                              }),
                              onOk: function onOk() {
                                axios.get(Common.baseApiUrl + "deletevitalsigns/" + selectedSign.id + "/" + Common.currentUser.id).then(function (response) {
                                  if (response.data.status == 200) {
                                    notification.success({
                                      message: "Ok!",
                                      description: response.data.message
                                    });
                                  } else {
                                    notification.error({
                                      message: "Erreur!",
                                      description: response.data.message
                                    });
                                  }
                                })["catch"](function (error) {
                                  notification.error({
                                    message: "Erreur!",
                                    description: response.data.message
                                  });
                                })["finally"](function () {});
                              }
                            });
                          },
                          children: /*#__PURE__*/_jsx(TrashFill, {
                            size: 16
                          })
                        })]
                      })
                    })]
                  }, e.id);
                })]
              })
            })
          }, {
            label: /*#__PURE__*/_jsx("b", {
              children: "Facturation"
            }),
            key: 3,
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Alert, {
                message: /*#__PURE__*/_jsx("b", {
                  children: "Total : " + totalAmount.toLocaleString("Fr")
                }),
                type: "info",
                showIcon: true
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
                striped: true,
                responsive: true,
                bordered: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Date"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "D\xE9signation"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Montant"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Agent"
                      })
                    }), /*#__PURE__*/_jsx("td", {})]
                  })
                }), /*#__PURE__*/_jsx("tbody", {
                  children: billsHistory.map(function (i) {
                    return /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsx(Moment, {
                          date: i.created_at,
                          format: "DD/MM/YYYY"
                        })
                      }), /*#__PURE__*/_jsx("td", {
                        children: i.business_account_medical_item.label
                      }), /*#__PURE__*/_jsx("td", {
                        children: i.business_account_medical_item.base_price.toLocaleString("Fr")
                      }), /*#__PURE__*/_jsx("td", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: i.bill.user.firstname + " " + i.bill.user.lastname
                        })
                      }), /*#__PURE__*/_jsx("td", {})]
                    }, i.id);
                  })
                })]
              })]
            })
          }]
        }), isPatientSearching && /*#__PURE__*/_jsx(Skeleton, {
          active: true
        })]
      })]
    }), selectedSign && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier les constantes"
        }),
        open: showEditVs,
        footer: null,
        destroyOnclose: true,
        onCancel: function onCancel() {
          setShowEditVs(false);
        },
        width: {
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(EditVitalSigns, {
          signs: selectedSign,
          handler: function handler() {
            setIsDataChanged(true);
          }
        })
      })
    })]
  });
};
export default Care;